import { useState, useEffect, useMemo } from "react";
import { DateTimeFormModal } from "./DateTimeFormModal";
import { formatDateRange } from "../../user/Ads/components/FilterModal/DateFormModal";
import { formatTimeRange } from "./DateTimeFormModal";
import { Stack, ActionList, ActionMenu, IconButton, Button } from '@primer/react';
import { FilterIcon, NumberIcon, ClockIcon, ChevronRightIcon } from '@primer/octicons-react'
import dayjs from "dayjs";

interface LogsFilterFormModalProps {
    filterOpened: boolean;
    setFilterOpened: (value: boolean) => void;

    dateFilterOpened: boolean;
    setDateFilterOpened: (value: boolean) => void;

    fromDate: string;
    setFromDate: (value: string) => void;
    toDate: string;
    setToDate: (value: string) => void;

    fromTime: string;
    setFromTime: (value: string) => void;
    toTime: string;
    setToTime: (value: string) => void;

    onDismiss: () => void;
    onApply: () => void;
}

const LogsFilterFormModal: React.FC<LogsFilterFormModalProps> = ({
    filterOpened,
    setFilterOpened,

    dateFilterOpened,
    setDateFilterOpened,

    fromDate,
    setFromDate,
    toDate,
    setToDate,

    fromTime,
    setFromTime,
    toTime,
    setToTime,

    onDismiss,
    onApply,
}) => {
    const rangeError = useMemo(() => {
        const fDate = (fromDate || "").trim();
        const tDate = (toDate || "").trim();
        const fTime = (fromTime || "").trim();
        const tTime = (toTime || "").trim();

        if (!fDate && !tDate && !fTime && !tTime) return false;

        const fromDateTime = dayjs(`${fDate || dayjs().format('YYYY-MM-DD')} ${fTime || '00:00'}`);
        const toDateTime = dayjs(`${tDate || dayjs().format('YYYY-MM-DD')} ${tTime || '23:59'}`);

        return !fromDateTime.isBefore(toDateTime);
    }, [fromDate, toDate, fromTime, toTime]);

    const dateModalDidDismiss = () => {
        setDateFilterOpened(false);
        setFilterOpened(true);
    };

    const handleDismiss = () => {
        setFilterOpened(false);
        onDismiss();
    };

    const handleApply = () => {
        setFilterOpened(false);
        onApply();
    };

    return (
        <>
            <DateTimeFormModal
                dateFilterOpened={dateFilterOpened}
                setDateFilterOpened={setDateFilterOpened}
                fromDate={fromDate}
                setFromDate={setFromDate}
                toDate={toDate}
                setToDate={setToDate}
                fromTime={fromTime}
                setFromTime={setFromTime}
                toTime={toTime}
                setToTime={setToTime}
                dateFormError={rangeError}
                onDismiss={dateModalDidDismiss}
                onApply={dateModalDidDismiss}
                isShowBackButton={true}
            />

            <ActionMenu open={filterOpened} onOpenChange={setFilterOpened}>
                <ActionMenu.Anchor>
                    <IconButton icon={FilterIcon} aria-label="Фильтр" />
                </ActionMenu.Anchor>
                <ActionMenu.Overlay className="!w-[260px]">
                    <ActionList selectionVariant="single" role="menu" aria-label="Item" className="!w-[260px]">
                        <ActionList.Group>
                            <ActionList.Item key="date" onSelect={() => setDateFilterOpened(true)}>
                                <ActionList.LeadingVisual>
                                    <ClockIcon />
                                </ActionList.LeadingVisual>
                                <p className="font-normal whitespace-pre-line">По дате и времени (UTC)</p>
                                <ActionList.TrailingVisual>
                                    <ChevronRightIcon />
                                </ActionList.TrailingVisual>
                                <ActionList.Description variant="block">
                                    {formatDateRange(fromDate, toDate)}<br></br>
                                    {formatTimeRange(fromTime, toTime)}
                                </ActionList.Description>
                            </ActionList.Item>
                        </ActionList.Group>

                        <Stack direction="horizontal" gap="normal" className="block mt-4 ml-[66px]">
                            <Button onClick={handleDismiss} size="small" variant="default">
                                Очистить
                            </Button>
                            <Button onClick={handleApply} size="small" variant="primary" disabled={rangeError}>
                                Применить
                            </Button>
                        </Stack>
                    </ActionList>
                </ActionMenu.Overlay>
            </ActionMenu>
        </>
    );
};

export default LogsFilterFormModal;